// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://vteypmmidmpwrcktxmcl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ0ZXlwbW1pZG1wd3Jja3R4bWNsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ1ODUwNTgsImV4cCI6MjA2MDE2MTA1OH0.mCr3ryESx3zFhI2E7Q3_Cqb6n8yX9-sIp4EqJ2_7msQ";
// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
